<script>
  import { fade } from 'svelte/transition';
  import { createEventDispatcher } from 'svelte';

  export let maxWidth = 'max-w-md';
  export let padding = '2rem';

  const dispatch = createEventDispatcher();

  function handleBackgroundClick(event) {
    if (event.target === event.currentTarget) {
      dispatch('close');
    }
  }
</script>

<button 
  type="button"
  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000] cursor-default" 
  on:click={handleBackgroundClick}
  transition:fade
>
  <div 
    class="bg-white rounded-lg relative overflow-y-auto overflow-x-hidden max-h-[90vh] {maxWidth} text-left"
    style="padding: {padding};"
  >
    <button 
      class="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
      on:click={() => dispatch('close')}
    >
      ✕
    </button>
    
    <slot />
  </div>
</button> 